export default "__VITE_ASSET__f5a57668__"